import { watch } from 'vue'
import { useAppStore } from '@/store'

// 弹窗接入 modalStatus 中心化触发: 外部 appStore.openModal({ id, params }), 组件自己接管显隐
// 用法:
//   const show = ref(false)
//   const { close } = useModal('ranking-rules', show)
//   <ui-modal :show="show" @close="close" />
//
// 带副作用(打开时启计时器 / 关闭时清理):
//   useModal('apply-notice', show, {
//     onOpen: (params) => { startTimer() },
//     onClose: () => { clearTimer() }
//   })
export function useModal(id, showRef, { onOpen, onClose } = {}) {
  const appStore = useAppStore()

  watch(
    () => appStore.modalStatus,
    ({ id: currentId, params }) => {
      if (currentId === id) {
        showRef.value = true
        onOpen?.(params)
      }
    },
    { deep: true }
  )

  return {
    close: () => {
      showRef.value = false
      onClose?.()
      appStore.closeModal()
    }
  }
}
